var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import NotifyService from '../../api/NotifyService';
import { Loading } from 'element-ui';
import GLOBAL_VUE from '../../globalVue';
var DetailRichText = (function (_super) {
    __extends(DetailRichText, _super);
    function DetailRichText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.tableHeight = 350;
        _this.detailData = {};
        _this.rowId = null;
        _this.order = {
            account_date: []
        };
        return _this;
    }
    DetailRichText.prototype.created = function () {
        this.service = NotifyService.getInstance();
        this.getNoticeDetail();
    };
    DetailRichText.prototype.getNoticeDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getNoticeDetail({
            notice_id: this.rowId
        }).then(function (res) {
            if (res.data.success) {
                console.log('res.data', res.data);
                _this.detailData = res.data.data;
                var MyComponent = Vue.extend({
                    template: "<div>" + res.data.data.notice_content + "</div>",
                });
                var component = new MyComponent().$mount();
                var $dom = document.querySelector("#richText");
                while ($dom.hasChildNodes()) {
                    $dom.removeChild($dom.firstChild);
                }
                $dom.appendChild(component.$el);
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    DetailRichText.prototype.confirm = function () {
        var _this = this;
        this.$confirm('确认后将不可撤消，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.confirmNotify({
                    notice_id: _this.rowId
                }).then(function (res) {
                    loadingInstance_1.close();
                    _this.$message.success(res.data.msg);
                    GLOBAL_VUE.$emit("closeTab", _this);
                    window._czc.push(["_trackEvent", '消息通知', '消息确认']);
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.message || err.msg);
                });
            }
        }).catch(function () { });
    };
    DetailRichText = __decorate([
        Component
    ], DetailRichText);
    return DetailRichText;
}(Vue));
export default DetailRichText;
